var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 22.8813C18.3794 22.8813 23.0347 18.2261 23.0347 12.5967C23.0347 6.95703 18.3794 2.31201 12.7397 2.31201C7.11035 2.31201 2.46533 6.95703 2.46533 12.5967C2.46533 18.2261 7.12061 22.8813 12.75 22.8813ZM12.75 21.5483C7.78711 21.5483 3.79834 17.5493 3.79834 12.5967C3.79834 7.63379 7.78711 3.63477 12.7397 3.63477C17.7026 3.63477 21.7017 7.63379 21.7119 12.5967C21.7119 17.5493 17.7129 21.5483 12.75 21.5483ZM12.6885 8.7207C13.3242 8.7207 13.8164 8.22852 13.8164 7.60303C13.8164 6.97754 13.3242 6.46484 12.6885 6.46484C12.063 6.46484 11.5605 6.97754 11.5605 7.60303C11.5605 8.22852 12.063 8.7207 12.6885 8.7207ZM10.9146 18.1851H15.1187C15.4468 18.1851 15.7031 17.939 15.7031 17.6108C15.7031 17.3032 15.4468 17.0469 15.1187 17.0469H13.6421V11.2944C13.6421 10.8843 13.4268 10.5972 13.0269 10.5972H11.0479C10.7197 10.5972 10.4634 10.8535 10.4634 11.1611C10.4634 11.4893 10.7197 11.7354 11.0479 11.7354H12.3911V17.0469H10.9146C10.5864 17.0469 10.3301 17.3032 10.3301 17.6108C10.3301 17.939 10.5864 18.1851 10.9146 18.1851Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleinfo);
export default __webpack_public_path__ + "static/media/Circle info.e02704748b52c6e9306278cf430bbb7e.svg";
export { ForwardRef as ReactComponent };